import { theme } from '@segment/react-ui-library'

export const color = {
  /**
   * Old Colors
   */
  green: {
    900: theme.rawColors.green900,
    800: theme.rawColors.green800,
    700: theme.rawColors.green700,
    600: theme.rawColors.green600,
    500: theme.rawColors.green500,
    400: theme.rawColors.green400,
    300: theme.rawColors.green300,
    200: theme.rawColors.green200,
    100: theme.rawColors.green100,
    50: theme.rawColors.green50
  },
  blue: {
    900: theme.rawColors.blue900,
    800: theme.rawColors.blue800,
    700: theme.rawColors.blue700,
    600: theme.rawColors.blue600,
    500: theme.rawColors.blue500,
    400: theme.rawColors.blue400,
    300: theme.rawColors.blue300,
    200: theme.rawColors.blue200,
    100: theme.rawColors.blue100,
    50: theme.rawColors.blue50
  },
  peach: {
    500: theme.rawColors.peach500,
    400: theme.rawColors.peach400,
    50: theme.rawColors.peach50
  },
  pink: {
    500: theme.rawColors.pink500,
    400: theme.rawColors.pink400,
    50: theme.rawColors.pink50
  },
  grey: {
    500: theme.rawColors.grey500,
    400: theme.rawColors.grey400,
    300: theme.rawColors.grey300,
    200: theme.rawColors.grey200,
    100: theme.rawColors.grey100,
    50: theme.rawColors.grey50
  },

  /**
   * New Colors
   */

  primary: theme.colors.primary,
  dark: theme.colors.dark,
  border: theme.colors.borderColor,
  active: theme.colors.activeColor,
  tint: theme.colors.backgroundTint1,
  tint2: theme.colors.backgroundTint2,
  white: '#FFFFFF',
  danger: theme.colors.danger,
  success: theme.colors.success,
  question: theme.colors.question,
  warning: theme.colors.warning,

  titleText: theme.textColors.title,
  bodyText: theme.textColors.body,
  mutedText: theme.textColors.muted
}

/**
 * Old Spacing
 */

export const space = {
  7: '16rem',
  6: '8rem',
  5: '4rem',
  4: '2rem',
  3: '1rem',
  2: '0.5rem',
  1: '0.25rem'
}



// WEBPACK FOOTER //
// ./ui/variables.js